import React from 'react';
import styles from './Onboarding.module.css';
import { Onboarding as OnboardingView } from '@/libs/onboarding';
import { OrganizationList } from './organizations/OrganizationList';
import { LocationsList } from './locations/LocationsList';
import { DeviceList } from './devices/DeviceList';
import { Logo } from '@oolio-group/design-ui-react';
import { Device, Organization, Store } from '@/libs/onboarding/types';
import { storageSvc } from '@/services/storageServiceClient';
import { LoadingSpinner } from '@/components/loading/Loading';
import { GET_DEVICES } from '@/queries/devices';
import { DeviceWithConfig } from '@/types/common';

interface OnboardingUIProps {
  onCompleted?: (
    organization: Organization,
    store: Store,
    device: Device,
  ) => void;
}

export const Onboarding: React.FC<OnboardingUIProps> = ({ onCompleted }) => {
  return (
    <div className={styles.bg}>
      <Logo
        brand="oolio"
        color="light"
        height={44}
        type="brandmark"
        width={44}
      />
      <div className={styles.locationsContainer}>
        <OnboardingView<DeviceWithConfig>
          onCompleted={onCompleted}
          renderOrganizations={OrganizationList}
          renderLocations={LocationsList}
          renderDevices={DeviceList}
          renderLoading={LoadingSpinner}
          storage={storageSvc}
          devicesConfig={{
            overrideDefaults: true,
            graphqlQuery: GET_DEVICES,
          }}
        />
      </div>
    </div>
  );
};
